import CaptainMcpServers from 'dashboard/api/captain/mcpServer';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'CaptainMcpServer',
  API: CaptainMcpServers,
  actions: mutations => ({
    update: async ({ commit }, { id, ...updateObj }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainMcpServers.update(id, updateObj);
        commit(mutations.EDIT, response.data);
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return throwErrorMessage(error);
      }
    },

    delete: async ({ commit }, id) => {
      commit(mutations.SET_UI_FLAG, { deletingItem: true });
      try {
        await CaptainMcpServers.delete(id);
        commit(mutations.DELETE, id);
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
        return id;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
        return throwErrorMessage(error);
      }
    },

    // Triggers synchronous server-side discovery (tools/list). Replaces
    // the cached record with the freshly-discovered version (success
    // case) or surfaces discovery_error on failure — server returns a
    // 422 with the error in the body when discovery fails.
    refresh: async ({ commit }, id) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainMcpServers.refresh(id);
        commit(mutations.EDIT, response.data);
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        // Even on 422, the server returns the updated record (with
        // discovery_error populated). Surface it to the store so the UI
        // can show the failure message inline.
        if (error?.response?.data?.id) {
          commit(mutations.EDIT, error.response.data);
        }
        return throwErrorMessage(error);
      }
    },
  }),
});
